import React from 'react';

/* Common */
import { Button } from '~/components/common';

export default function ConversionFlowSubmit({
    flow,
    handleClose = () => { },
    theme = 'primary',
    title = flow?.form?.buttonLabel,
    className = 'mt-2 text-truncate',
    attributes = {
     type: 'submit'
    },
    ...passProps
}) {
    const activeStep = flow?.steps.find((step) => step.active);

    return (
        <Button
            className={className}
            theme={theme}
            title={title}
            attributes={attributes}
            {...passProps}
            onClick={(e) => {
                if (activeStep?.last) {
                    e.preventDefault();
                    handleClose();
                }
            }}
        />
    )
}
